export * from './textResults.service';